import Immutable from 'immutable';
import ContentWarningConstants from 'app/constants/ContentWarningConstants';

const initialState = Immutable.fromJS({
  defaults: {
    spoilersVisible: true,
    offensiveContentVisible: true
  }
});

export default function contentWarnings(state = initialState, action) {
  switch (action.type) {
    case ContentWarningConstants.SHOW_CONTENT: {
      return state.merge(
        Immutable.fromJS({ [action.contentId]: { spoilersVisible: true, offensiveContentVisible: true } })
      );
    }

    case ContentWarningConstants.HIDE_CONTENT: {
      return state.merge(
        Immutable.fromJS({ [action.contentId]: { spoilersVisible: false, offensiveContentVisible: false } })
      );
    }

    case ContentWarningConstants.SHOW_OFFENSIVE_CONTENT_SUCCESS: {
      return state.map(settings => settings.set('offensiveContentVisible', true));
    }

    case ContentWarningConstants.HIDE_OFFENSIVE_CONTENT_SUCCESS: {
      return state.map(settings => settings.set('offensiveContentVisible', false));
    }

    case ContentWarningConstants.SHOW_SPOILERS_SUCCESS: {
      return state.map(settings => settings.set('spoilersVisible', true));
    }

    case ContentWarningConstants.HIDE_SPOILERS_SUCCESS: {
      return state.map(settings => settings.set('spoilersVisible', false));
    }

    default:
      return state;
  }
}
